<template>
  <div class="home">
    <LoginForm />
  </div>
</template>
<script>
import LoginForm from './components/LoginForm'

export default {
  components: {
    LoginForm
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
